import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Fixed from './Components/fixed'
// Importing components
import ACSERVICE from './Components/ac-service';
import FRIDGESERVICE from './Components/fridge-service';
import TVSERVICE from './Components/tv-service';
import MICROWAVEOVEN from './Components/microwave-oven-service';
import WASHINGMACHINESERVICE from './Components/washing-machine-service';
import WATERHEATERSERVICE from './Components/water-heater-service';
import WATERPURIFIERSERVICE from './Components/water-purifier-service';
import PRIVACYPOLICY from './Components/privacy-policy';
import TERMSCONDITIONS from './Components/terms-conditions';
import ABOUT from './Components/About';
import CONTACT from './Components/contact';
import Navbar from './H&F/Navbar';
import Footer from './H&F/Footer';
import Discliamer from './Components/Discliamer';
// App.js
import HOME from './Components/Home';  // Correct default import


function App() {
  return (

    <>
    <Fixed/>
    <Router>
      <div>
        {/* Define Routes */}
        <Routes>
          <Route path="/" element={<HOME />} />
          <Route path="/About" element={<ABOUT />} />
          <Route path="/ac-service" element={<ACSERVICE />} />
          <Route path="/fridge-service" element={<FRIDGESERVICE />} />
          <Route path="/tv-service" element={<TVSERVICE />} />
          <Route path="/microwave-oven-service" element={<MICROWAVEOVEN />} />
          <Route path="/washing-machine-service" element={<WASHINGMACHINESERVICE />} />
          <Route path="/water-heater-service" element={<WATERHEATERSERVICE />} />
          <Route path="/water-purifier-service" element={<WATERPURIFIERSERVICE />} />
          <Route path="/privacy-policy" element={<PRIVACYPOLICY />} />
          <Route path="/terms-conditions" element={<TERMSCONDITIONS />} />
          <Route path="/contact" element={<CONTACT />} />
          <Route path="/Footer" element={<Footer />} />
          <Route path="/Navbar" element={<Navbar />} />
          <Route path="/Discliamer" element={<Discliamer />} />
        </Routes>
      </div>
    </Router>





</>

  );
}

export default App;
